import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'

// 首页轮播
if ( window.innerWidth> 768) {
    var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
	pagination: {
      el: ".banner .swiper-pagination",
      clickable: true,
    },
}); 
}


// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s > $(".section3").offset().top - $("header").height() * 2 && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop(); 
    if (s >$(".section3").offset().top - $("header").height() * 2  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})

$(".section4 ul li.active").click(function() {
    $(".section4 .content .text").fadeToggle();
})

var swiper2 = new Swiper(".section4 .swiper", {
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 30,
        },
        768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 20,
        },
        320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        }
    } 
}); 